function gateWayServiceManagement() {
  let gateWayService = [
    {
      name: "GateWay Mangement",
      icon: "gateway-management",
      logoName: "TransactionHistory",
      // flag: "voucherRequired",
      displayService: "gatewayManagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        // path: "/index/gateway-management",
        path: "/index/transaction-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const Transaction = () => {
    const profileArr = [
      {
        path: "/index/transaction",
        name: "transaction",
        icon: "transaction",
        logoName: "TransactionHistory",
        flag: "TRANSACTION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };
  // const refundPartner = () => {
  //   const profileArrs = [
  //     {
  //       path: "/index/Refund",
  //       name: "Refund",
  //       icon: "fee-master",
  //       logoName: "RECEIVED",
  //       flag: "REFUND"

  //     },
  //   ];
  //   return profileArrs;
  // };




  let a = dashboard();
  let b = Transaction();
  // let c = refundPartner()

  gateWayService[0].items = [...a, ...b];

  return gateWayService;
}

export default gateWayServiceManagement;
